import React from "react";
import { pad } from "../utils";
import { ChevronDown } from "./icons/ChevronDown";
import { ChevronUp } from "./icons/ChevronUp";

export const ModalHours = ({
  hours,
  minutes,
  addHours,
  addMinutes,
  subHours,
  subMinutes,
}) => {
  return (
    <div className="modal-hours">
      <div className="modal-time">
        <span>{pad(hours)}</span>
        <div>
          <button
            onMouseDown={() => addHours()}
            onMouseUp={() => addHours(true)}
            onTouchStart={() => addHours()}
            onTouchEnd={() => addHours(true)}
            className="btn"
          >
            <ChevronUp />
          </button>
          <button
            onMouseDown={() => subHours()}
            onMouseUp={() => subHours(true)}
            onTouchStart={() => subHours()}
            onTouchEnd={() => subHours(true)}
            className="btn"
          >
            <ChevronDown />
          </button>
        </div>
      </div>
      <div className="modal-time">
        <span>{pad(minutes)}</span>
        <div>
          <button
            onMouseDown={() => addMinutes()}
            onMouseUp={() => addMinutes(true)}
            onTouchStart={() => addMinutes()}
            onTouchEnd={() => addMinutes(true)}
            className="btn"
          >
            <ChevronUp />
          </button>
          <button
            onMouseDown={() => subMinutes()}
            onMouseUp={() => subMinutes(true)}
            onTouchStart={() => subMinutes()}
            onTouchEnd={() => subMinutes(true)}
            className="btn"
          >
            <ChevronDown />
          </button>
        </div>
      </div>
      <div className="modal-hours-tip">
        <small>Tip: Hold the buttons pressed to keep the value changing.</small>
      </div>
    </div>
  );
};
